type DataBucketRowSkeletonProps = {
  count?: number;
  showPrefix?: boolean;
  prefixClassName?: string;
  rowClassName?: string;
};

const DataBucketRowSkeleton = ({
  count = 3,
  showPrefix = true,
  prefixClassName,
  rowClassName = "px-4 py-2",
}: DataBucketRowSkeletonProps) => {
  const defaultPrefixClassName = "text-xs font-semibold uppercase text-gray-400";
  const finalPrefixClassName = prefixClassName || defaultPrefixClassName;

  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`skeleton-shimmer-${index}`}
          className={`relative overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm ${rowClassName}`}
        >
          <div className="flex items-center gap-2">
            {showPrefix && (
              <span className={finalPrefixClassName}>
                {prefixClassName?.includes("bg-slate") ? "#" : ""}
                {String(index + 1).padStart(2, "0")}
              </span>
            )}
            <div className="relative h-5 w-32 overflow-hidden rounded bg-gray-200">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
            </div>
            <div className="ml-auto flex items-center gap-1">
              <div className="relative h-6 w-6 overflow-hidden rounded-full bg-gray-200">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="relative h-6 w-6 overflow-hidden rounded-full bg-gray-200">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent [animation-delay:0.2s]" />
              </div>
              <div className="relative h-6 w-6 overflow-hidden rounded-full bg-gray-200">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent [animation-delay:0.4s]" />
              </div>
            </div>
          </div>
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent pointer-events-none" />
        </div>
      ))}
    </div>
  );
};

export default DataBucketRowSkeleton;
